const VALIDATION_MESSAGE_TRANSLATIONS = [
  {
    match: /^Input should be a valid number$/i,
    format: () => 'introduza um número válido',
  },
  {
    match: /^Input should be a valid integer$/i,
    format: () => 'introduza um número inteiro válido',
  },
  {
    match: /^Field required$/i,
    format: () => 'campo obrigatório',
  },
  {
    match: /^Input should be a valid string$/i,
    format: () => 'introduza um texto válido',
  },
  {
    match: /^Input should be a valid boolean$/i,
    format: () => 'seleccione um valor válido',
  },
  {
    match: /^String should have at least (\d+) characters$/i,
    format: (match) => `deve ter pelo menos ${match[1]} caracteres`,
  },
  {
    match: /^String should have at most (\d+) characters$/i,
    format: (match) => `deve ter no máximo ${match[1]} caracteres`,
  },
  {
    match: /^Input should be greater than or equal to (.+)$/i,
    format: (match) => `deve ser maior ou igual a ${match[1]}`,
  },
  {
    match: /^Input should be less than or equal to (.+)$/i,
    format: (match) => `deve ser menor ou igual a ${match[1]}`,
  },
];

function humanizeFieldName(fieldName) {
  return String(fieldName || '')
    .replace(/_/g, ' ')
    .replace(/\bid\b/gi, 'ID')
    .replace(/^./, (value) => value.toUpperCase());
}

function translateValidationMessage(message) {
  if (!message || typeof message !== 'string') return 'valor inválido';

  for (const translation of VALIDATION_MESSAGE_TRANSLATIONS) {
    const match = message.match(translation.match);
    if (match) {
      return translation.format(match);
    }
  }

  return message;
}

function formatValidationEntry(entry, options = {}) {
  if (typeof entry === 'string') return entry;

  const fieldLabels = options.fieldLabels || {};
  const locationParts = Array.isArray(entry?.loc) ? entry.loc.filter(Boolean) : [];
  const fieldKey = locationParts[locationParts.length - 1];
  const fieldLabel = fieldLabels[fieldKey] || humanizeFieldName(fieldKey);
  const translatedMessage = options.translateValidation
    ? translateValidationMessage(entry?.msg)
    : entry?.msg;

  if (!fieldLabel) return translatedMessage || 'Erro de validação';
  return `${fieldLabel}: ${translatedMessage || 'Erro de validação'}`;
}

export function normalizeApiError(err, fallbackMessage = 'Erro inesperado', options = {}) {
  const safeMeta = err?.__safeMeta;
  if (safeMeta?.endpoint) {
    if (safeMeta.timedOut) {
      return `Timeout ao carregar ${safeMeta.endpoint}`;
    }
    if (safeMeta.httpStatus) {
      return `${safeMeta.endpoint}: ${safeMeta.errorMessage || `HTTP ${safeMeta.httpStatus}`}`;
    }
    if (safeMeta.errorMessage) {
      return `${safeMeta.endpoint}: ${safeMeta.errorMessage}`;
    }
  }

  const data = err?.response?.data;
  const detail = data?.detail ?? data;

  if (!detail) return err?.message || fallbackMessage;
  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    const messages = detail.map((entry) => formatValidationEntry(entry, options));
    return messages.join(' | ');
  }

  if (typeof detail === 'object' && detail?.msg) {
    return formatValidationEntry(detail, options);
  }
  if (typeof detail === 'object' && detail?.message) return String(detail.message);

  try {
    return JSON.stringify(detail);
  } catch {
    return fallbackMessage;
  }
}